import React from 'react';
import { View, Image, Dimensions, ScrollView, StyleSheet, Platform, ActivityIndicator, ImageBackground,SafeAreaView } from 'react-native';
 
import Colors from '../../constants/theme';
 
import { getFullContentCurrentAffairs } from '../../store/action';
import { connect } from 'react-redux';
// import AdsScreen from '../Ads';
import { Text } from "./../../components/UI-Components"
import Header from './../../components/Header/index';
import Skeleton from '@material-ui/lab/Skeleton';
import Container from '@material-ui/core/Container';



// const HtmlContent = ({text}) => {   
//     return (
//         <HTML  
//         imagesMaxWidth={deviceWidth}
//         tagsStyles={{
//             span: {fontFamily: Colors.quizFont}
//         }}
//         baseFontStyle={{fontSize: 16, textAlign: 'justify', fontWeight:'400', color:'rgba(0,0,0,0.7)'}}        
//         html={text} 
//     />)
// }


class CurrentAffairsModal extends React.Component {


    componentDidMount() {
        const { params } = this.props.match;
        const { titleId } = params || {};
        console.log(this.props);
        // const { titleId, fromList } = state || {};
        if(titleId) {
            this.props.getFullContentCurrentAffairs(titleId);
        }else {
            // this.props.history.replace('/Home');
        }
    }


    render() {

        const { fullContentDescription, loading, error } = this.props;        

        return (
           <div className={`${loading ? "loginBox" : 'full-height'} `}>

            <View  style={{flex:1, backgroundColor: '#ecf2f7'}}>
                <View style={{...styles.mainContainer,}}>                   
                    <Header 
                        title="Current Affairs"
                        headerRight
                        headerRightClick={() => this.props.history.push('/Home')}
                        headerLeftClick={() => this.props.history.goBack()}
                        backButton={true}
                        // headerRightClick={() => alert()}
                    />
                    <Container maxWidth='lg'>
                    {
                        fullContentDescription && !loading
                            ?
                            (
                                <View style={{flex: 1, }}>
                                    <Image 
                                    source={{ uri: fullContentDescription.url }} 
                                    style={styles.CurrentAffairsImg}
                                     resizeMode='contain' />
                                    
                                        <ScrollView style={
                                            { paddingHorizontal: 8, textAlign: 'justify', paddingBottom: 50, flex: 1, marginBottom: 10, margin: 'auto', }
                                        }>
                                          
                                            <div dangerouslySetInnerHTML={{__html: fullContentDescription.content}} style={{padding: 5, userSelect :' none'}}>

                                            </div>
                                                                                     
                                        </ScrollView>
                                </View>
                               
                            )
                            :
                            (error && !loading)
                                ? (
                                    <View style={{flex: 1, marginTop: 30, height: '100%'}}>
                                        <Text style={{textAlign: 'center'}}>
                                            Results Not Found
                                    </Text>
                                    </View>
                                )
                                : 
                                loading 
                                ?
                                (
                                    <View style={{ flex: 1, width: '100%', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
                                        <ActivityIndicator />                                       
                                    </View>
                                )
                                : (
                                    <View style={{flex: 1, marginTop: 30}}>
                                        <Text style={{textAlign: 'center'}}>
                                            Results Not Found
                                    </Text>
                                    </View>
                                )
                    }
                    </Container>
                </View>
                {/* ================ads screen ====================== */}
                {/* <AdsScreen screenName="CurrentAffairs" /> */}
        {/* ================ads screen end ====================== */}
            </View>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    loading: state.currentAffairs && state.currentAffairs.fullDescriptionLoading && state.currentAffairs.fullDescriptionLoading,
    error: state.currentAffairs && state.currentAffairs.fullDescriptionError && state.currentAffairs.fullDescriptionError,
    errInfo: state.currentAffairs && state.currentAffairs.fullDescriptionErrInfo && state.currentAffairs.fullDescriptionErrInfo,
    fullContentDescription: state.currentAffairs && state.currentAffairs.fullDescriptionResponse && state.currentAffairs.fullDescriptionResponse.current_affairs && state.currentAffairs.fullDescriptionResponse.current_affairs
})

export default connect(mapStateToProps, { getFullContentCurrentAffairs })(CurrentAffairsModal);

const styles = StyleSheet.create({
    splashBackgroundImage: {
        width: '100%',
        height: '100%',
    },
    mainContainer: {
        flex: 1,
        justifyContent: 'flex-start',
        paddingHorizontal: 5,
        backgroundColor: '#fff',

    },
    description: {  
        color: Colors.black,
        fontSize: 14,
        marginBottom: 5,
    },
    CurrentAffairsImg: {
        width: '98%',
        minHeight: 200,
        marginVertical: 10
    }
})
